import { CDBBtn } from 'cdbreact';
import { get } from '../../api/usersModule/httpClient';
import Select from "react-select";
import { useEffect, useState } from 'react';

export const ModalRoles = ({
	action,
	setPressedButton,
	formData,
	handleChange,
	handleStatusChange,
	handleModuleChange,
	handleOperationCheck,
	checkedOperations,
	selectedModule,
}) => {
	const [modules, setModules] = useState([]);
	const [operations, setOperations] = useState([]);
	const getModules = async () => {
		try {
			const modules = await get('/modules');
			const moduleTransformed = modules.items.map(item => ({
				value: item.ModuleID,
				label: item.ModuleName
			}));
			setModules(moduleTransformed);
		} catch (error) {
			console.error(error);
			setModules([]);
		}
	};

	const getOperations = async () => {
		try {
			const operations = await get('/operations');
			const operationNames = operations.items.map((item) => item.OperationName);
			setOperations(operationNames);
		} catch (error) {
			console.error(error);
			setOperations([]);
		}
	};

	useEffect(() => {
		getModules();
		getOperations();
	}, []);

	return (
		<div>
			<div className='modal-header'>
				<div>
					<h3 className='modal-title' id='exampleModalLabel'>
						{action === 'create' ? 'Crear Rol' : 'Editando Rol'}
					</h3>
				</div>
				{action === 'edit' ? (
					<CDBBtn
						size='small'
						className='p-2 btn'
						color='danger'
						outline
						onClick={() => {
							setPressedButton('delete');
						}}
					>
						<i className='fas fa-trash'></i>
						Eliminar Rol
					</CDBBtn>
				) : null}
			</div>
			<div className='modal-body'>
				<div className='form-group'>
					<div className='form-check mb-4 form-check-inline'>
						<input
							className='form-check-input'
							type='checkbox'
							name='RoleStatus'
							id='RoleStatus'
							checked={formData.RoleStatus}
							onChange={handleStatusChange}
						/>
						<label className='form-check-label' htmlFor='RoleStatus'>
							Estado actual: {formData.RoleStatus ? 'Activo' : 'Inactivo'}
						</label>
					</div>
				</div>

				{action !== 'create' ? (
					<div className='form-group'>
						<label>Id</label>
						<input
							type='text'
							className='form-control mb-4'
							id='RoleID'
							placeholder='Id'
							disabled
							value={formData.RoleID}
						/>
					</div>
				) : null}

				<div className='form-group'>
					<label htmlFor='RoleName'>Nombre:<span className="text-danger"> *</span></label>
					<input
						type='text'
						className='form-control mb-4'
						id='RoleName'
						placeholder='Operación'
						value={formData.RoleName}
						onChange={handleChange}
					/>
				</div>

				<div className='form-group'>
					<label htmlFor='OperationDescription'>Descripción:</label>
					<textarea
						className='form-control mb-4'
						id='RoleDesc'
						placeholder='Descripción'
						value={formData.RoleDesc}
						onChange={handleChange}
					/>
				</div>

				<div className='form-group'>
					<label htmlFor='OperationDescription'>Modulos:<span className="text-danger"> *</span></label>
					<Select
						id='ModuleID'
						options={modules}
						value={modules.find((option) => option.value === formData.ModuleID)}
						onChange={(selectedOption) => {
							handleModuleChange({ id: "ModuleID", value: selectedOption.label });
						}}
					/>
				</div>

				{selectedModule !== '' ? (
					<div className='form-group'>
						<label>Operaciones:</label>
						{operations.map((item) => {
							return (
								<div key={item} className='form-check g-3'>
									<input
										className='form-check-input'
										type='checkbox'
										name='OperationID'
										id={item}
										value={item}
										onChange={() => {
											handleOperationCheck(item);
										}}
										checked={checkedOperations.includes(item)}
									/>
									<label className='form-check-label' htmlFor={item}>
										{item}
									</label>
								</div>
							);
						})}
					</div>
				) : null}

				<div className='modal-footer justify-content-center align-items-center'>
					<CDBBtn
						type='button'
						color='danger'
						outline
						onClick={() => setPressedButton('closeModal')}
					>
						Cerrar
					</CDBBtn>
					<CDBBtn
						type='submit'
						color='success'
						className='mr-auto'
						outline
						onClick={() => setPressedButton('submitModal')}
					>
						Guardar
					</CDBBtn>
				</div>
			</div>
		</div>
	);
};
